import { useNavigate } from 'react-router-dom';
import { useMutation } from '@tanstack/react-query';

import useAuth from '../../auth/useAuth';
import AuthService from '../../auth/AuthService';

import Layout from '../UI/introGameLayout/layout';
import OnboardingProcess from '../UI/onboarding/process';

import { updateUser } from './api';

export default function Onboarding() {
  const navigate = useNavigate();

  const { getUser } = useAuth();
  const user = getUser();

  const updateUserMutation = useMutation({
    mutationFn: (data) => updateUser(data),
  });

  const handleOnboardingComplete = async () => {
    updateUserMutation.mutate({
      id: user.id,
      onboarded: true
    });

    // Keep the locally cached user in sync so the Login redirect logic
    // sees onboarded=true immediately without waiting for a re-fetch.
    const cachedUser = AuthService.getUser();
    if (cachedUser) {
      AuthService.setUser({ ...cachedUser, onboarded: true });
    }

    let redirectUrl;

    if(user?.alias_name) {
      redirectUrl = '/assignments';
    } else {
      redirectUrl = '/onboarding/preferred-name'
    }

    navigate(redirectUrl);
  }
  return (
    <Layout
      isHeaderVisible={false}
      isContentVertical={true}
      backgroundColor={'linear-gradient(135deg, #EC5E59 2.88%, rgba(146, 219, 225, 0.8) 99.03%)'}
      className="onboarding-layout"
    >
      <OnboardingProcess
        onFinish={handleOnboardingComplete}
      />
    </Layout>
  );
}
